import { useTranslation } from "react-i18next";
import { ScrollNavLink } from "../../app/NavBar/NavBarElements";
import { ReactElement } from "react";
import { getScrollAttributes } from "../../../utils/getScrollAttributes";

const HowWeWorkLink = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <ScrollNavLink
      activeClass="selectedLink"
      {...getScrollAttributes("howDoWe")}
    >
      {t("ourModel")}
    </ScrollNavLink>
  );
};

export default HowWeWorkLink;
